import { FC, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import type { AppBarProps } from '@material-ui/core';
import { AppBar, Box, Hidden, Toolbar, useMediaQuery } from '@material-ui/core';
import { experimentalStyled, useTheme } from '@material-ui/core/styles';
import LanguagePopover from './LanguagePopover';
import logoImageApp from '../../images/sa-white.svg'
import logoNameApp from '../../images/sa-white-text.svg'
import { useTranslation } from 'react-i18next';

interface NavbarProps extends AppBarProps {
}

const NavbarRoot = experimentalStyled(AppBar)(
  ({ theme }) => (
    {
      ...(
        theme.palette.mode === 'light' && {
          backgroundColor: theme.palette.primary.main,
          boxShadow: 'none',
          color: theme.palette.primary.contrastText
        }
      ),
      ...(
        theme.palette.mode === 'dark' && {
          backgroundColor: theme.palette.background.paper,
          borderBottom: `1px solid ${theme.palette.divider}`,
          boxShadow: 'none'
        }
      ),
      zIndex: theme.zIndex.drawer + 100
    }
  )
);

const Navbar: FC<NavbarProps> = (props) => {
  const [actualTime, setActualTime] = useState<string>('');

  const { i18n } = useTranslation();

  const updateActualTime = () => {
    const now = new Date();
    const day = now.getUTCDate().toString().padStart(2, '0');
    const month = (now.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = now.getUTCFullYear();
    const hours = now.getUTCHours().toString().padStart(2, '0');
    const minutes = now.getUTCMinutes().toString().padStart(2, '0');

    const utcString = `${day}/${month}/${year} ${hours}:${minutes}`;

    setActualTime(utcString);
  }

  var currentTheme = useTheme();
  const mobileDevice = useMediaQuery(currentTheme.breakpoints.down(380));

  setInterval(updateActualTime, 10000);

  useEffect(() => {
    updateActualTime();
  }, [i18n.language]);



  return (
    <NavbarRoot>
      <Toolbar sx={{ minHeight: 64 }}>

        {!mobileDevice ? (<>
          <RouterLink to="/">
            <Box
              sx={{
                mt: '6px',
              }}
              component="img"
              src={logoImageApp}
              height={40}
            />
            <Box
              sx={{
                mb: '15px',
                mx: 1
              }}
              component="img"
              src={logoNameApp}
              height={14}
            />
          </RouterLink></>) : (<>
            <Box
              sx={{
                mt: '6px',
              }}
              component="img"
              src={logoImageApp}
              height={40}
            /></>)}

        <Box
          sx={{
            flexGrow: 1,
            ml: 2
          }}
        />
        <Box sx={{ mr: 6 }}>
          {//{actualTime} UTC}
          }
        </Box>
        <LanguagePopover />
      </Toolbar>
    </NavbarRoot>
  );
};

export default Navbar;
